<template>
  <b-overlay :show="isLoading">
    <b-row>
      <b-col cols="12">
        <b-card>
          <h1 class="mb-3">آزمون های در انتظار تصحیح</h1>
          <b-table
            class="position-relative mt-2"
            :items="examsList"
            responsive
            :fields="myTableColumns"
            primary-key="discountId"
            show-empty
            bordered
            striped
            empty-text="آزمون در انتظار تصحیحی وجود ندارد!"
          >
            <template #cell(createDate)="data">
              {{ new Date(data.item.createDate).toLocaleDateString("fa-IR") }}
            </template>
            <template #cell(status)="data">
              <b-badge :variant="examStatusBadgeColors[data.item.status]">
                {{ examStatuses[data.item.status] }}
              </b-badge>
            </template>
            <template #cell(actions)="data">
              <b-link
                class="btn btn-primary"
                :to="{
                  name: 'apps-master-exams-id',
                  params: { id: data.item.examId },
                }"
              >
                تصحیح آزمون
              </b-link>
            </template>
          </b-table>
        </b-card>
      </b-col>
    </b-row>
  </b-overlay>
</template>
<script>
import { GetAllSchedulesForMaster } from "@/libs/Api/Schedules";
import { GetAllExams } from "@/libs/Api/Exam";
import { getUserData } from "@/auth/utils";
export default {
  mounted() {
    this.getMasterAllExams();
  },
  data() {
    return {
      isLoading: false,
      examsList: null,
      count: 10,
      pageNumber: 1,
      totalCount: null,
      examStatusBadgeColors: {
        1: "warning",
        2: "secondary",
        3: "success",
        4: "danger",
        5: "danger",
        6: "danger",
      },
      examStatuses: {
        1: "در انتظار برگزاری",
        2: "در انتظار نتیجه",
        3: "قبول شده",
        4: "رد شده",
        5: "غیبت زبان آموز",
        6: "غیبت استاد",
      },
      myTableColumns: [
        {
          key: "examId",
          label: "شناسه آزمون",
        },
        {
          key: "lessonTitle",
          label: "عنوان درس",
        },
        {
          key: "studentFullName",
          label: "زبان آموز",
        },
        {
          key: "status",
          label: "وضعیت آزمون",
        },
        {
          key: "createDate",
          label: "تاریخ ایجاد",
        },
        {
          key: "actions",
          label: "عملیات",
        },
      ],
    };
  },
  methods: {
    async getMasterAllExams() {
      try {
        this.isLoading = true;
        let _this = this;
        let getAllExams = new GetAllExams(_this);
        getAllExams.setRequestParam({
          count: _this.count,
          pageNumber: _this.pageNumber,
          masterUserId: getUserData().user.userId,
          status: 2,
        });
        await getAllExams.fetch((response) => {
          if (response.isSuccess) {
            _this.examsList = response.data.exams;
            _this.totalCount = response.data.examsCount;
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
  components: {
    BCard,
    BRow,
    BCol,
    BTable,
    BLink,
    BBadge,
    BOverlay,
  },
};
import {
  BCard,
  BRow,
  BCol,
  BTable,
  BLink,
  BBadge,
  BOverlay,
} from "bootstrap-vue";
</script>
